@let blocCompetences = bloc();

<div class="border-grey-3 py-sm gap-sm flex rounded-lg border bg-white">
  <div class="px-sm gap-xs flex flex-1 flex-col">
    <span class="paragraph-large-semibold">Compétences</span>
    <p class="paragraph-large-medium" [innerHTML]="blocCompetences.listeCompetences" style="white-space: pre-line"></p>
  </div>
  <div class="border-grey-3 border-l"></div>
  <div class="px-sm gap-xs flex flex-1 flex-col">
    <span class="paragraph-large-semibold">Gestion des compétences de certification</span>
    @for (competence of blocCompetences.competences; track competence.id) {
      <app-competence
        [competence]="competence"
        (competenceChange)="editCompetence($event)"
        (onDelete)="deleteCompetence(competence)"
        canEdit
      />
    }
    <div
      class="border-grey-3 p-md hover:bg-background-alternative-light cursor-pointer rounded-lg border border-dashed"
      (click)="addCompetence()"
    >
      <div class="gap-sm flex items-center">
        <div class="size-lg bg-grey-2 flex items-center justify-center rounded-full">
          <ng-icon name="lucidePlus" />
        </div>
        <span class="paragraph-medium-medium">Réécrire une compétence de la certification</span>
      </div>
    </div>
  </div>
</div>

<div class="gap-sm px-xl py-sm border-grey-3 fixed right-0 bottom-0 left-0 flex border-t bg-white">
  <button [routerLink]="['..']" hlmBtn variant="secondary" type="button">
    <ng-icon name="lucideArrowLeft" />
    Retourner aux blocs de compétences
  </button>
  <button (click)="submit()" hlmBtn type="button">
    Valider les compétences
    <ng-icon name="lucideCheck" />
  </button>
</div>
